/**
 * Clipping Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.8.25
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ClientSavedAnalyticsViewResponse {
    id?: string;
    name?: string;
    screen?: 'OVERVIEW' | 'COVERAGE_DASHBOARD' | 'COVERAGE_ANALYSIS' | 'BRANDS' | 'TOPICS' | 'SENTIMENT' | 'MEDIA';
    coverageAnalysisTab?: string;
    filtersJson?: string;
    createdAt?: Date;
    updatedAt?: Date;
}
